<div class="tab-group">
  @for(button of tabButtonGroup(); track button.label) {
    <button 
      class="tab-button" 
      [class.selected]="button.selected"
      (click)="onTabClick(button)"
    >
      <span>{{ button.label }}</span>
    </button>
  }
</div>